import {InvestorAddress} from '@/types/client-info';

export const mapClientAddress = (address?: InvestorAddress): string | null => {
  if (!address) {
    return null;
  }

  const {streetNo, streetTypeCode, streetName} = address;

  return [streetNo, streetTypeCode, streetName].filter(Boolean).join(' ');
};
